import { Routes } from '@angular/router';
import { ActivityWizardDeactivateGuard } from '@core/guards/activity-wizard-deactivate.guard';
import { authGuard } from '@core/guards/auth.guard';
import { eseguiAttivitaDeactivateGuard } from '@core/guards/esegui-attivita-deactivate.guard';
import { mobileOnlyGuard } from '@core/guards/mobile-only.guard';
import { permissionGuard } from '@core/guards/permission.guard';
import { resetStoreGuard } from '@core/guards/reset-store.guard';
import { clearDataDisponibileGuard } from '@core/guards/clear-data-disponibile.guard';
import { risorseGuard } from '@core/guards/risorse.guard';
import { IDRISORSEFLUSSO, IDRISORSESIDENAV } from '@core/utils/const';

export const routes: Routes = [
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./pages/auth-pages/login/login.component').then(
            (m) => m.LoginComponent,
          ),
        canActivate: [authGuard],
      },
      {
        path: 'change-password',
        data: { email: undefined },
        loadComponent: () =>
          import('./pages/auth-pages/change-password/change-password.component').then(
            (m) => m.ChangePasswordComponent,
          ),
        // canActivate: [authGuard],
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./pages/auth-pages/forgot-password/forgot-password.component').then(
            (m) => m.ForgotPasswordComponent,
          ),
      },
    ],
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./pages/home/home.component').then((x) => x.HomeComponent),
    canActivate: [authGuard],
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./pages/dashboard/dashboard.component').then(
        (x) => x.DashboardComponent,
      ),
  },
  // clienti
  {
    path: 'clienti',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/features_shared/clienti/clienti.component').then(
            (x) => x.ClientiComponent,
          ),
      },
      {
        path: 'nuovo-cliente',
        loadComponent: () =>
          import('./pages/features_shared/clienti/new-client/new-client.component').then(
            (x) => x.NewClientComponent,
          ),
        data: {
          idSidenav: [IDRISORSESIDENAV.clienti],
          breadcrumb: [
            { name: 'breadcrumb_client.list', route: 'clienti' },
            { name: 'breadcrumb_client.new', route: 'nuovo-cliente' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        path: 'dettaglio-cliente/:idCliente',
        loadComponent: () =>
          import('./pages/features_shared/clienti/details-client/details-client.component').then(
            (x) => x.DetailsClientComponent,
          ),
        data: {
          breadcrumb: [
            { name: 'breadcrumb_client.list', route: 'clienti' },
            { name: 'breadcrumb_client.details', route: 'dettaglio-cliente' },
          ],
        },
      },
      {
        path: 'modifica-cliente/:idCliente',
        loadComponent: () =>
          import('./pages/features_shared/clienti/new-client/new-client.component').then(
            (x) => x.NewClientComponent,
          ),
        data: {
          idSidenav: [IDRISORSESIDENAV.clienti],
          breadcrumb: [
            { name: 'breadcrumb_client.list', route: 'clienti' },
            { name: 'breadcrumb_client.edit', route: 'modifica-cliente' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        path: 'dettaglio-cliente/:idCliente/dettaglio-cantiere/:idCantiere',
        loadComponent: () =>
          import('./pages/features/cantieri-ambiti-tariffari/cantieri/cantieri-details/cantieri-details.component').then(
            (x) => x.CantieriDetailsComponent,
          ),
        data: {
          breadcrumb: [
            { name: 'breadcrumb_client.list', route: 'clienti' },
            { name: 'breadcrumb_client.details', route: 'dettaglio-cliente' },
            { name: 'breadcrumb_site.details', route: 'dettaglio-cantiere' },
          ],
        },
      },
      {
        path: 'dettaglio-cliente/:idCliente/nuovo-cantiere',
        loadComponent: () =>
          import('./pages/features/cantieri-ambiti-tariffari/cantieri/new-cantieri/new-cantieri.component').then(
            (x) => x.NewCantieriComponent,
          ),
        data: {
          idFlusso: [IDRISORSEFLUSSO.cantieri],
          breadcrumb: [
            { name: 'breadcrumb_client.list', route: 'clienti' },
            { name: 'breadcrumb_client.details', route: 'dettaglio-cliente' },
            { name: 'breadcrumb_site.new', route: 'nuovo-cantiere' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        path: 'dettaglio-cliente/:idCliente/modifica-cantiere/:idCantiere',
        loadComponent: () =>
          import('./pages/features/cantieri-ambiti-tariffari/cantieri/new-cantieri/new-cantieri.component').then(
            (x) => x.NewCantieriComponent,
          ),
        data: {
          idFlusso: [IDRISORSEFLUSSO.cantieri],
          breadcrumb: [
            { name: 'breadcrumb_client.list', route: 'clienti' },
            { name: 'breadcrumb_client.details', route: 'dettaglio-cliente' },
            { name: 'breadcrumb_site.edit', route: 'modifica-cantiere' },
          ],
        },
        canActivate: [permissionGuard],
      },
    ],
    canActivate: [risorseGuard],
    data: { idSidenav: [IDRISORSESIDENAV.clienti] },
  },
  // campagne-programmate
  {
    path: 'campagne-programmate',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/features/distribuzione-censimento/campagne-programmate/campagne-programmate.component').then(
            (x) => x.CampagneProgrammateComponent,
          ),
      },
      {
        path: 'nuova-campagna',
        loadComponent: () =>
          import('./pages/features/distribuzione-censimento/campagne-programmate/nuova-campagna-programmata/nuova-campagna-programmata.component').then(
            (x) => x.NuovaCampagnaProgrammataComponent,
          ),
        data: {
          idSidenav: [IDRISORSESIDENAV.campagne],
          breadcrumb: [
            { name: 'breadcrumb_campaign.list', route: 'campagne-programmate' },
            { name: 'breadcrumb_campaign.new', route: 'nuova-campagna' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        path: 'dettaglio-campagna/:idCampagna',
        loadComponent: () =>
          import('./pages/features/distribuzione-censimento/campagne-programmate/dettaglio-campagne-programmate/dettaglio-campagne-programmate.component').then(
            (x) => x.DettaglioCampagneProgrammateComponent,
          ),
        data: {
          breadcrumb: [
            { name: 'breadcrumb_campaign.list', route: 'campagne-programmate' },
            {
              name: 'breadcrumb_campaign.details',
              route: 'dettaglio-campagna',
            },
          ],
        },
      },
      {
        path: 'dettaglio-campagna/:idCampagna/associa-utenze',
        loadComponent: () =>
          import('./pages/features/distribuzione-censimento/campagne-programmate/associa-utenze-campagna/associa-utenze-campagna.component').then(
            (x) => x.AssociaUtenzeCampagnaComponent,
          ),
        data: {
          idSidenav: [IDRISORSESIDENAV.campagne],
          breadcrumb: [
            { name: 'breadcrumb_campaign.list', route: 'campagne-programmate' },
            {
              name: 'breadcrumb_campaign.details',
              route: 'dettaglio-campagna',
            },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        path: 'modifica-campagna/:idCampagna',
        loadComponent: () =>
          import('./pages/features/distribuzione-censimento/campagne-programmate/nuova-campagna-programmata/nuova-campagna-programmata.component').then(
            (x) => x.NuovaCampagnaProgrammataComponent,
          ),
        data: {
          idSidenav: [IDRISORSESIDENAV.campagne],
          breadcrumb: [
            { name: 'breadcrumb_campaign.list', route: 'campagne-programmate' },
            { name: 'breadcrumb_campaign.edit', route: 'modifica-campagna' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        path: 'aggiungi-kit-campagna',
        loadComponent: () =>
          import('./pages/features/attrezzature/kit-attrezzature/new-kit/new-kit.component').then(
            (x) => x.NewKitComponent,
          ),
        data: {
          idSidenav: [IDRISORSESIDENAV.campagne],
          breadcrumb: [
            { name: 'breadcrumb_campaign.list', route: 'campagne-programmate' },
            { name: 'breadcrumb_campaign.edit', route: 'modifica-campagna' },
          ],
        },
        canActivate: [permissionGuard],
      },
    ],
    canActivate: [risorseGuard],
    data: { idSidenav: [IDRISORSESIDENAV.campagne] },
  },
  // attivita
  {
    path: 'attivita',
    canDeactivate: [resetStoreGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/features/distribuzione-censimento/attivita/attivita.component').then(
            (x) => x.AttivitaComponent,
          ),
      },
      {
        path: 'nuovo-soggetto',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/soggetti/new-soggetto/new-soggetto.component').then(
            (x) => x.NewSoggettoComponent,
          ),
        data: {
          idSidenav: [IDRISORSESIDENAV.attivita],
          breadcrumb: [
            { name: 'breadcrumb_activity.list', route: 'attivita' },
            { name: 'breadcrumb_subjects.new', route: 'nuovo-soggetto' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        path: 'modifica-soggetto/:idSoggetto',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/soggetti/new-soggetto/new-soggetto.component').then(
            (x) => x.NewSoggettoComponent,
          ),
        data: {
          idSidenav: [IDRISORSESIDENAV.attivita],
          breadcrumb: [
            { name: 'breadcrumb_activity.list', route: 'attivita' },
            { name: 'Modifica soggetto', route: 'modifica-soggetto' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        path: 'dettaglio-soggetto/:idSoggetto',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/soggetti/details-soggetto/details-soggetto.component').then(
            (x) => x.DetailsSoggettoComponent,
          ),
        data: {
          idSidenav: [IDRISORSESIDENAV.attivita],
          breadcrumb: [
            { name: 'breadcrumb_activity.list', route: 'attivita' },
            { name: 'Dettaglio soggetto', route: 'dettaglio-soggetto' },
          ],
        },
        canActivate: [permissionGuard],
      },

      {
        // aggiungi nuova utenza
        path: 'nuova-utenza/:idSoggetto',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/utenze/new-utenza/new-utenza.component').then(
            (x) => x.NewUtenzaComponent,
          ),
        data: {
          idSidenav: [IDRISORSESIDENAV.attivita],
          breadcrumb: [
            { name: 'breadcrumb_activity.list', route: 'attivita' },
            { name: 'breadcrumb_utilities.new', route: 'nuova-utenza' },
          ],
        },
        canActivate: [permissionGuard],
      },
      // dettaglio utenza
      {
        path: 'dettaglio-utenza/:idUtenza',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/utenze/details-utenza/details-utenza.component').then(
            (x) => x.DetailsUtenzaComponent,
          ),
        data: {
          breadcrumb: [
            { name: 'breadcrumb_activity.list', route: 'anagrafica-soggetti' },
            { name: 'breadcrumb_utilities.details', route: 'dettaglio-utenza' },
          ],
        },
      },
      {
        // aggiungi idSoggetto e idUtenza se nn 'è idUtenza allora è nuova utenza
        path: 'modifica-utenza/:idUtenza',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/utenze/new-utenza/new-utenza.component').then(
            (x) => x.NewUtenzaComponent,
          ),
        data: {
          breadcrumb: [
            { name: 'breadcrumb_activity.list', route: 'anagrafica-soggetti' },
            { name: 'breadcrumb_utilities.edit', route: 'modifica-utenza' },
          ],
        },
      },
      {
        path: 'modifica-attivita/:idAttivita',
        loadComponent: () =>
          import('./pages/features/distribuzione-censimento/attivita/modifica-attivita/modifica-attivita.component').then(
            (x) => x.ModificaAttivitaComponent,
          ),
        data: {
          idSidenav: [IDRISORSESIDENAV.attivita],
          breadcrumb: [
            { name: 'breadcrumb_activity.list', route: 'attivita' },
            {
              name: 'breadcrumb_activity.details',
              route: 'modifica-attivita/:idAttivita',
            },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        path: 'dettaglio-attivita/:idAttivita',
        loadComponent: () =>
          import('./pages/features/distribuzione-censimento/attivita/dettaglio-attivita/dettaglio-attivita.component').then(
            (x) => x.DettaglioAttivitaComponent,
          ),
        data: {
          breadcrumb: [
            { name: 'breadcrumb_activity.list', route: 'attivita' },
            {
              name: 'breadcrumb_activity.details',
              route: 'dettaglio-attivita/:idAttivita',
            },
          ],
        },
      },
      {
        path: 'dettaglio-attivita/:idAttivita/esegui',
        loadComponent: () =>
          import('./pages/features/distribuzione-censimento/attivita/esegui-attivita/esegui-attivita.component').then(
            (x) => x.EseguiAttivitaComponent,
          ),
        data: {
          breadcrumb: [
            { name: 'breadcrumb_activity.list', route: 'attivita' },
            {
              name: 'breadcrumb_activity.details',
              route: 'dettaglio-attivita',
            },
            { name: 'Esegui attività', route: '/esegui' },
          ],
        },
        canDeactivate: [eseguiAttivitaDeactivateGuard],
      },
      {
        path: 'nuova-attivita/:idUtenza',
        loadComponent: () =>
          import('./pages/features/distribuzione-censimento/attivita/nuova-attivita/nuova-attivita.component').then(
            (x) => x.NuovaAttivitaComponent,
          ),
        data: {
          idSidenav: [IDRISORSESIDENAV.attivita],
          breadcrumb: [
            { name: 'breadcrumb_activity.list', route: 'attivita' },
            {
              name: 'breadcrumb_activity.new',
              route: 'nuova-attivita/utenza/:idUtenza',
            },
          ],
        },
        canActivate: [permissionGuard],
      },
      // modifica utenza da soggetto
      {
        path: 'dettaglio-soggetto/:idSoggetto/modifica-utenza/:idUtenza',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/utenze/new-utenza/new-utenza.component').then(
            (x) => x.NewUtenzaComponent,
          ),
        data: {
          breadcrumb: [
            { name: 'breadcrumb_activity.list', route: 'attivita' },
            {
              name: 'breadcrumb_subjects.details',
              route: 'dettaglio-soggetto',
            },
            { name: 'breadcrumb_utilities.edit', route: 'modifica-utenza' },
          ],
        },
      },
      {
        // aggiungi nuova utenza da attività
        path: 'dettaglio-soggetto/:idSoggetto/nuova-utenza',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/utenze/new-utenza/new-utenza.component').then(
            (x) => x.NewUtenzaComponent,
          ),
        data: {
          idSidenav: [IDRISORSESIDENAV.attivita],
          breadcrumb: [
            { name: 'breadcrumb_activity.list', route: 'attivita' },
            { name: 'breadcrumb_subjects.new', route: 'dettaglio-soggetto' },
            { name: 'breadcrumb_utilities.new', route: 'nuova-utenza' },
          ],
        },
        canActivate: [permissionGuard],
      },
      // dettaglio utenza da soggetto
      {
        path: 'dettaglio-soggetto/:idSoggetto/dettaglio-utenza/:idUtenza',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/utenze/details-utenza/details-utenza.component').then(
            (x) => x.DetailsUtenzaComponent,
          ),
        data: {
          breadcrumb: [
            { name: 'breadcrumb_activity.list', route: 'attivita' },
            {
              name: 'breadcrumb_subjects.details',
              route: 'dettaglio-soggetto',
            },
            { name: 'breadcrumb_utilities.details', route: 'dettaglio-utenza' },
          ],
        },
      },
      // TODOa che serve questo path?
      {
        path: 'nuova-attivita/:idSoggetto',
        redirectTo: 'nuova-attivita/soggetto/:idSoggetto',
      },
      //TODO: Ottimizzae flusso wizard, è stato fatto esterno per renderlo agnostico dal macrocomponente in cui si trova
      {
        path: 'wizard/:idSoggetto/:activityType',
        loadComponent: () =>
          import('./pages/features/distribuzione-censimento/attivita/activity-wizard/activity-wizard.component').then(
            (x) => x.ActivityWizardComponent,
          ),
        data: {
          idSidenav: [IDRISORSESIDENAV.attivita],
          breadcrumb: [
            { name: 'breadcrumb_activity.list', route: 'attivita' },
            {
              name: 'breadcrumb_activity.new',
              route: 'nuova-attivita/:idSoggetto',
            },
            {
              name: 'breadcrumb_activity.wizard',
              route: 'wizard/:idSoggetto/:activityType',
            },
          ],
        },
        canActivate: [permissionGuard],
        canDeactivate: [ActivityWizardDeactivateGuard],
      },
    ],
    canActivate: [risorseGuard],
    data: { idSidenav: [IDRISORSESIDENAV.attivita] },
  },
  // distribuzione-anagrafica-soggetti
  {
    path: 'distribuzione-anagrafica-soggetti',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/anagrafica-soggetti-utenze-condomini.component').then(
            (x) => x.AnagraficaSoggettiUtenzeCondominiComponent,
          ),
      },
      {
        path: 'nuovo-soggetto',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/soggetti/new-soggetto/new-soggetto.component').then(
            (x) => x.NewSoggettoComponent,
          ),
        data: {
          idFlusso: [IDRISORSEFLUSSO.distribuzione_soggetti],
          breadcrumb: [
            {
              name: 'breadcrumb_subjects.subjects',
              route: 'anagrafica-soggetti',
            },
            { name: 'breadcrumb_subjects.new', route: 'nuovo-soggetto' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        path: 'nuovo-soggetto/:idUtenza',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/soggetti/new-soggetto/new-soggetto.component').then(
            (x) => x.NewSoggettoComponent,
          ),
        data: {
          idFlusso: [IDRISORSEFLUSSO.distribuzione_soggetti],
          breadcrumb: [
            {
              name: 'breadcrumb_subjects.subjects',
              route: 'anagrafica-soggetti',
            },
            { name: 'breadcrumb_subjects.edit', route: 'modifica-soggetto' },
            { name: 'breadcrumb_subjects.transfer', route: 'dettaglio-utenza' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        path: 'modifica-soggetto/:idSoggetto',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/soggetti/new-soggetto/new-soggetto.component').then(
            (x) => x.NewSoggettoComponent,
          ),
        data: {
          idFlusso: [IDRISORSEFLUSSO.distribuzione_soggetti],
          breadcrumb: [
            {
              name: 'breadcrumb_subjects.subjects',
              route: 'anagrafica-soggetti',
            },
            { name: 'breadcrumb_subjects.edit', route: 'modifica-soggetto' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        path: 'dettaglio-soggetto/:idSoggetto',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/soggetti/details-soggetto/details-soggetto.component').then(
            (x) => x.DetailsSoggettoComponent,
          ),
        data: {
          breadcrumb: [
            {
              name: 'breadcrumb_subjects.subjects',
              route: 'anagrafica-soggetti',
            },
            {
              name: 'breadcrumb_subjects.details',
              route: 'dettaglio-soggetto',
            },
          ],
        },
      },
      // utenze
      {
        // aggiungi nuova utenza
        path: 'nuova-utenza/:idSoggetto',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/utenze/new-utenza/new-utenza.component').then(
            (x) => x.NewUtenzaComponent,
          ),
        data: {
          idFlusso: [IDRISORSEFLUSSO.distribuzione_utenze],
          breadcrumb: [
            {
              name: 'breadcrumb_subjects.subjects',
              route: 'anagrafica-soggetti',
            },
            { name: 'breadcrumb_utilities.new', route: 'nuova-utenza' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        // aggiungi nuova utenza da soggetti
        path: 'dettaglio-soggetto/:idSoggetto/nuova-utenza',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/utenze/new-utenza/new-utenza.component').then(
            (x) => x.NewUtenzaComponent,
          ),
        data: {
          idFlusso: [IDRISORSEFLUSSO.distribuzione_utenze],
          breadcrumb: [
            {
              name: 'breadcrumb_subjects.subjects',
              route: 'anagrafica-soggetti',
            },
            {
              name: 'breadcrumb_subjects.details',
              route: 'dettaglio-soggetto',
            },
            { name: 'breadcrumb_utilities.new', route: 'nuova-utenza' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        // aggiungi idSoggetto e idUtenza se nn 'è idUtenza allora è nuova utenza
        path: 'modifica-utenza/:idUtenza',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/utenze/new-utenza/new-utenza.component').then(
            (x) => x.NewUtenzaComponent,
          ),
        data: {
          idFlusso: [IDRISORSEFLUSSO.distribuzione_utenze],
          breadcrumb: [
            {
              name: 'breadcrumb_subjects.subjects',
              route: 'anagrafica-soggetti',
            },
            { name: 'breadcrumb_utilities.edit', route: 'modifica-utenza' },
          ],
        },
        canActivate: [permissionGuard],
      },
      // modifica utenza da soggetto
      {
        path: 'dettaglio-soggetto/:idSoggetto/modifica-utenza/:idUtenza',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/utenze/new-utenza/new-utenza.component').then(
            (x) => x.NewUtenzaComponent,
          ),
        data: {
          idFlusso: [IDRISORSEFLUSSO.distribuzione_utenze],
          breadcrumb: [
            {
              name: 'breadcrumb_subjects.subjects',
              route: 'anagrafica-soggetti',
            },
            {
              name: 'breadcrumb_subjects.details',
              route: 'dettaglio-soggetto',
            },
            { name: 'breadcrumb_utilities.edit', route: 'modifica-utenza' },
          ],
        },
        canActivate: [permissionGuard],
      },
      // dettaglio utenza
      {
        path: 'dettaglio-utenza/:idUtenza',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/utenze/details-utenza/details-utenza.component').then(
            (x) => x.DetailsUtenzaComponent,
          ),
        data: {
          breadcrumb: [
            {
              name: 'breadcrumb_subjects.subjects',
              route: 'anagrafica-soggetti',
            },
            { name: 'breadcrumb_utilities.details', route: 'dettaglio-utenza' },
          ],
        },
      },
      // dettaglio utenza da soggetto
      {
        path: 'dettaglio-soggetto/:idSoggetto/dettaglio-utenza/:idUtenza',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/utenze/details-utenza/details-utenza.component').then(
            (x) => x.DetailsUtenzaComponent,
          ),
        data: {
          breadcrumb: [
            {
              name: 'breadcrumb_subjects.subjects',
              route: 'anagrafica-soggetti',
            },
            {
              name: 'breadcrumb_subjects.details',
              route: 'dettaglio-soggetto',
            },
            { name: 'breadcrumb_utilities.details', route: 'dettaglio-utenza' },
          ],
        },
      },

      // condomini
      // TODO TRADUZIONE BREADCRUMB
      {
        path: 'nuovo-condominio',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/condomini/new-condomini/new-condomini.component').then(
            (x) => x.NewCondominiComponent,
          ),
        data: {
          idFlusso: [IDRISORSEFLUSSO.distribuzione_condominio],
          breadcrumb: [
            {
              name: 'breadcrumb_subjects.subjects',
              route: 'anagrafica-soggetti',
            },
            { name: 'Nuovo condominio', route: 'nuovo-condominio' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        path: 'modifica-condominio/:idCondominio',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/condomini/new-condomini/new-condomini.component').then(
            (x) => x.NewCondominiComponent,
          ),
        data: {
          idFlusso: [IDRISORSEFLUSSO.distribuzione_condominio],
          breadcrumb: [
            {
              name: 'breadcrumb_subjects.subjects',
              route: 'anagrafica-soggetti',
            },
            { name: 'Modifica condominio', route: 'modifica-condominio' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        path: 'dettaglio-condominio/:idCondominio',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/condomini/details-condomini/details-condomini.component').then(
            (x) => x.DetailsCondominiComponent,
          ),
        data: {
          breadcrumb: [
            {
              name: 'breadcrumb_subjects.subjects',
              route: 'anagrafica-soggetti',
            },
            { name: 'Dettaglio condominio', route: 'dettaglio-condominio' },
          ],
        },
      },
      {
        path: 'dettaglio-condominio/:idCondominio/associa-nuove-utenze',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/condomini/associa-nuove-utenze/associa-nuove-utenze.component').then(
            (x) => x.AssociaNuoveUtenzeComponent,
          ),
        data: {
          idFlusso: [IDRISORSEFLUSSO.distribuzione_condominio],
          breadcrumb: [
            {
              name: 'breadcrumb_subjects.subjects',
              route: 'anagrafica-soggetti',
            },
            { name: 'Dettaglio condominio', route: 'dettaglio-condominio' },
            { name: 'Associa nuove utenze', route: 'associa-nuove-utenze' },
          ],
        },
        canActivate: [permissionGuard],
      },
    ],
    canActivate: [risorseGuard],
    data: { idSidenav: [IDRISORSESIDENAV.distribuzione_anagrafica_soggetti] },
  },
  // rfid-power (mobile-only)
  {
    path: 'rfid-power',
    loadComponent: () =>
      import('./pages/features_shared/rfid-power-management/rfid-power-management.component').then(
        (m) => m.RfidPowerManagementComponent,
      ),
    canActivate: [authGuard, mobileOnlyGuard],
    data: {},
  },
  // ambiti
  {
    path: 'ambiti-tariffari',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/features/cantieri-ambiti-tariffari/ambiti-tariffari/ambiti-tariffari.component').then(
            (x) => x.AmbitiTariffariComponent,
          ),
      },
      {
        path: 'nuovo-ambito',
        loadComponent: () =>
          import('./pages/features/cantieri-ambiti-tariffari/ambiti-tariffari/new-tariffarea/new-tariffarea.component').then(
            (x) => x.NewTariffareaComponent,
          ),
        data: {
          idSidenav: [IDRISORSESIDENAV.ambiti],
          breadcrumb: [
            { name: 'breadcrumb_tariff_scope.list', route: 'ambiti-tariffari' },
            { name: 'breadcrumb_tariff_scope.new', route: 'nuovo-ambito' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        path: 'modifica-ambito/:id',
        loadComponent: () =>
          import('./pages/features/cantieri-ambiti-tariffari/ambiti-tariffari/new-tariffarea/new-tariffarea.component').then(
            (x) => x.NewTariffareaComponent,
          ),
        data: {
          idSidenav: [IDRISORSESIDENAV.ambiti],
          breadcrumb: [
            { name: 'breadcrumb_tariff_scope.list', route: 'ambiti-tariffari' },
            { name: 'breadcrumb_tariff_scope.edit', route: 'modifica-ambito' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        path: 'dettaglio-ambito/:id',
        loadComponent: () =>
          import('./pages/features/cantieri-ambiti-tariffari/ambiti-tariffari/tariffarea-details/tariffarea-details.component').then(
            (x) => x.TariffareaDetailsComponent,
          ),
        data: {
          breadcrumb: [
            { name: 'breadcrumb_tariff_scope.list', route: 'ambiti-tariffari' },
            {
              name: 'breadcrumb_tariff_scope.details',
              route: 'dettaglio-ambito',
            },
          ],
        },
      },
    ],
    canActivate: [risorseGuard],
    data: { idSidenav: [IDRISORSESIDENAV.ambiti] },
  },
  // soggetti
  {
    path: 'anagrafica-soggetti',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/anagrafica-soggetti-utenze-condomini.component').then(
            (x) => x.AnagraficaSoggettiUtenzeCondominiComponent,
          ),
      },
      {
        path: 'nuovo-soggetto',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/soggetti/new-soggetto/new-soggetto.component').then(
            (x) => x.NewSoggettoComponent,
          ),
        data: {
          idFlusso: [IDRISORSEFLUSSO.soggetti],
          breadcrumb: [
            {
              name: 'breadcrumb_subjects.subjects',
              route: 'anagrafica-soggetti',
            },
            { name: 'breadcrumb_subjects.new', route: 'nuovo-soggetto' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        path: 'nuovo-soggetto/:idUtenza',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/soggetti/new-soggetto/new-soggetto.component').then(
            (x) => x.NewSoggettoComponent,
          ),
        data: {
          idFlusso: [IDRISORSEFLUSSO.soggetti],
          breadcrumb: [
            {
              name: 'breadcrumb_subjects.subjects',
              route: 'anagrafica-soggetti',
            },
            { name: 'breadcrumb_subjects.edit', route: 'modifica-soggetto' },
            { name: 'breadcrumb_subjects.transfer', route: 'dettaglio-utenza' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        path: 'modifica-soggetto/:idSoggetto',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/soggetti/new-soggetto/new-soggetto.component').then(
            (x) => x.NewSoggettoComponent,
          ),
        data: {
          idFlusso: [IDRISORSEFLUSSO.soggetti],
          breadcrumb: [
            {
              name: 'breadcrumb_subjects.subjects',
              route: 'anagrafica-soggetti',
            },
            { name: 'breadcrumb_subjects.edit', route: 'modifica-soggetto' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        path: 'dettaglio-soggetto/:idSoggetto',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/soggetti/details-soggetto/details-soggetto.component').then(
            (x) => x.DetailsSoggettoComponent,
          ),
        data: {
          breadcrumb: [
            {
              name: 'breadcrumb_subjects.subjects',
              route: 'anagrafica-soggetti',
            },
            {
              name: 'breadcrumb_subjects.details',
              route: 'dettaglio-soggetto',
            },
          ],
        },
      },
      // utenze
      {
        // aggiungi nuova utenza
        path: 'nuova-utenza/:idSoggetto',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/utenze/new-utenza/new-utenza.component').then(
            (x) => x.NewUtenzaComponent,
          ),
        data: {
          idFlusso: [IDRISORSEFLUSSO.utenze],
          breadcrumb: [
            {
              name: 'breadcrumb_subjects.subjects',
              route: 'anagrafica-soggetti',
            },
            { name: 'breadcrumb_utilities.new', route: 'nuova-utenza' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        // aggiungi nuova utenza da soggetti
        path: 'dettaglio-soggetto/:idSoggetto/nuova-utenza',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/utenze/new-utenza/new-utenza.component').then(
            (x) => x.NewUtenzaComponent,
          ),
        data: {
          idFlusso: [IDRISORSEFLUSSO.utenze],
          breadcrumb: [
            {
              name: 'breadcrumb_subjects.subjects',
              route: 'anagrafica-soggetti',
            },
            {
              name: 'breadcrumb_subjects.details',
              route: 'dettaglio-soggetto',
            },
            { name: 'breadcrumb_utilities.new', route: 'nuova-utenza' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        // aggiungi idSoggetto e idUtenza se nn 'è idUtenza allora è nuova utenza
        path: 'modifica-utenza/:idUtenza',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/utenze/new-utenza/new-utenza.component').then(
            (x) => x.NewUtenzaComponent,
          ),
        data: {
          idFlusso: [IDRISORSEFLUSSO.utenze],
          breadcrumb: [
            {
              name: 'breadcrumb_subjects.subjects',
              route: 'anagrafica-soggetti',
            },
            { name: 'breadcrumb_utilities.edit', route: 'modifica-utenza' },
          ],
        },
        canActivate: [permissionGuard],
      },
      // modifica utenza da soggetto
      {
        path: 'dettaglio-soggetto/:idSoggetto/modifica-utenza/:idUtenza',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/utenze/new-utenza/new-utenza.component').then(
            (x) => x.NewUtenzaComponent,
          ),
        data: {
          idFlusso: [IDRISORSEFLUSSO.utenze],
          breadcrumb: [
            {
              name: 'breadcrumb_subjects.subjects',
              route: 'anagrafica-soggetti',
            },
            {
              name: 'breadcrumb_subjects.details',
              route: 'dettaglio-soggetto',
            },
            { name: 'breadcrumb_utilities.edit', route: 'modifica-utenza' },
          ],
        },
        canActivate: [permissionGuard],
      },
      // dettaglio utenza
      {
        path: 'dettaglio-utenza/:idUtenza',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/utenze/details-utenza/details-utenza.component').then(
            (x) => x.DetailsUtenzaComponent,
          ),
        data: {
          breadcrumb: [
            {
              name: 'breadcrumb_subjects.subjects',
              route: 'anagrafica-soggetti',
            },
            { name: 'breadcrumb_utilities.details', route: 'dettaglio-utenza' },
          ],
        },
      },
      // dettaglio utenza da soggetto
      {
        path: 'dettaglio-soggetto/:idSoggetto/dettaglio-utenza/:idUtenza',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/utenze/details-utenza/details-utenza.component').then(
            (x) => x.DetailsUtenzaComponent,
          ),
        data: {
          breadcrumb: [
            {
              name: 'breadcrumb_subjects.subjects',
              route: 'anagrafica-soggetti',
            },
            {
              name: 'breadcrumb_subjects.details',
              route: 'dettaglio-soggetto',
            },
            { name: 'breadcrumb_utilities.details', route: 'dettaglio-utenza' },
          ],
        },
      },

      // condomini
      // TODO TRADUZIONE BREADCRUMB
      {
        path: 'nuovo-condominio',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/condomini/new-condomini/new-condomini.component').then(
            (x) => x.NewCondominiComponent,
          ),
        data: {
          idFlusso: [IDRISORSEFLUSSO.condominio],
          breadcrumb: [
            {
              name: 'breadcrumb_subjects.subjects',
              route: 'anagrafica-soggetti',
            },
            { name: 'Nuovo condominio', route: 'nuovo-condominio' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        path: 'modifica-condominio/:idCondominio',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/condomini/new-condomini/new-condomini.component').then(
            (x) => x.NewCondominiComponent,
          ),
        data: {
          idFlusso: [IDRISORSEFLUSSO.condominio],
          breadcrumb: [
            {
              name: 'breadcrumb_subjects.subjects',
              route: 'anagrafica-soggetti',
            },
            { name: 'Modifica condominio', route: 'modifica-condominio' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        path: 'dettaglio-condominio/:idCondominio',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/condomini/details-condomini/details-condomini.component').then(
            (x) => x.DetailsCondominiComponent,
          ),
        data: {
          breadcrumb: [
            {
              name: 'breadcrumb_subjects.subjects',
              route: 'anagrafica-soggetti',
            },
            { name: 'Dettaglio condominio', route: 'dettaglio-condominio' },
          ],
        },
      },
      {
        path: 'dettaglio-condominio/:idCondominio/associa-nuove-utenze',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/condomini/associa-nuove-utenze/associa-nuove-utenze.component').then(
            (x) => x.AssociaNuoveUtenzeComponent,
          ),
        data: {
          idFlusso: [IDRISORSEFLUSSO.condominio],
          breadcrumb: [
            {
              name: 'breadcrumb_subjects.subjects',
              route: 'anagrafica-soggetti',
            },
            { name: 'Dettaglio condominio', route: 'dettaglio-condominio' },
            { name: 'Associa nuove utenze', route: 'associa-nuove-utenze' },
          ],
        },
        canActivate: [permissionGuard],
      },
    ],
    canActivate: [risorseGuard],
    canDeactivate: [resetStoreGuard],
    data: { idSidenav: [IDRISORSESIDENAV.anagrafica_soggetti] },
  },
  // attrezzature
  // TODO TRADUZIONE BREADCRUMB
  {
    path: 'attrezzature',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/features/attrezzature/attrezzature.component').then(
            (x) => x.AttrezzatureComponent,
          ),
      },
      {
        path: 'details-senza-tag/:idSenzaTag',
        loadComponent: () =>
          import('./pages/features/attrezzature/senza-tag/details-senza-tag/details-senza-tag.component').then(
            (x) => x.DetailsSenzaTagComponent,
          ),
        data: {
          breadcrumb: [
            { name: 'Lista senza codice', route: 'attrezzature' },
            { name: 'Dettaglio attrezzatura', route: 'details-senza-tag' },
          ],
        },
      },
      {
        path: 'nuovo-senza-tag',
        loadComponent: () =>
          import('./pages/features/attrezzature/senza-tag/new-senza-tag/new-senza-tag.component').then(
            (x) => x.NewSenzaTagComponent,
          ),
        data: {
          idFlusso: [IDRISORSEFLUSSO.senzaTag],
          breadcrumb: [
            { name: 'Lista senza codice', route: 'attrezzature' },
            { name: 'Nuove attrezzature', route: 'nuovo-senza-tag' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        path: 'dettaglio-con-tag/:id',
        loadComponent: () =>
          import('./pages/features/attrezzature/con-tag/details-con-tag/details-con-tag.component').then(
            (x) => x.DetailsConTagComponent,
          ),
        data: {
          breadcrumb: [
            { name: 'Lista con codice', route: 'attrezzature' },
            { name: 'Dettaglio attrezzatura', route: 'dettaglio-con-tag' },
          ],
        },
      },
      {
        path: 'modifica-con-tag/:id',
        loadComponent: () =>
          import('./pages/features/attrezzature/con-tag/new-con-tag/new-con-tag.component').then(
            (x) => x.NewConTagComponent,
          ),
        data: {
          idFlusso: [IDRISORSEFLUSSO.conTag],
          breadcrumb: [
            { name: 'Lista con codice', route: 'attrezzature' },
            { name: 'Modifica attrezzatura', route: 'modifica-con-tag' },
          ],
        },
        canActivate: [permissionGuard],
      },
    ],
    canActivate: [risorseGuard],
    data: { idSidenav: [IDRISORSESIDENAV.anagrafica] },
  },
  //Flotta
  {
    path: 'flotta',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/features/flotta/flotta-mezzi/flotta-mezzi.component').then(
            (x) => x.FlottaMezziComponent,
          ),
      },
    ],
    canActivate: [risorseGuard],
    data: { idSidenav: [IDRISORSESIDENAV.flotta] },
  },
  //KIT
  {
    path: 'kit',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/features/attrezzature/kit-attrezzature/kit.component').then(
            (x) => x.KitComponent,
          ),
      },
      {
        path: 'dettaglio-kit/:id',
        loadComponent: () =>
          import('./pages/features/attrezzature/kit-attrezzature/details-kit/details-kit.component').then(
            (x) => x.DetailsKitComponent,
          ),
        data: {
          breadcrumb: [
            { name: 'breadcrumb_kit.list', route: 'kit' },
            { name: 'breadcrumb_kit.details', route: 'dettaglio-kit' },
          ],
        },
      },
      {
        path: 'new-kit',
        loadComponent: () =>
          import('./pages/features/attrezzature/kit-attrezzature/new-kit/new-kit.component').then(
            (x) => x.NewKitComponent,
          ),
        data: {
          idSidenav: [IDRISORSESIDENAV.kit],
          breadcrumb: [
            { name: 'breadcrumb_kit.list', route: 'kit' },
            { name: 'breadcrumb_kit.new', route: 'new-kit' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        path: 'modifica-kit/:id',
        loadComponent: () =>
          import('./pages/features/attrezzature/kit-attrezzature/new-kit/new-kit.component').then(
            (x) => x.NewKitComponent,
          ),
        data: {
          idSidenav: [IDRISORSESIDENAV.kit],
          breadcrumb: [
            { name: 'breadcrumb_kit.list', route: 'kit' },
            { name: 'breadcrumb_kit.modify_kit', route: 'modifica-kit' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        path: 'duplica-kit/:id',
        loadComponent: () =>
          import('./pages/features/attrezzature/kit-attrezzature/new-kit/new-kit.component').then(
            (x) => x.NewKitComponent,
          ),
        data: {
          idSidenav: [IDRISORSESIDENAV.kit],
          breadcrumb: [
            { name: 'breadcrumb_kit.list', route: 'kit' },
            {
              name: 'breadcrumb_kit.duplicate',
              route: 'duplica-kit',
              isDuplica: true,
            },
          ],
        },
        canActivate: [permissionGuard],
      },
    ],
    canActivate: [risorseGuard],
    data: { idSidenav: [IDRISORSESIDENAV.kit] },
  },
  // CCR
  {
    path: 'dettaglio-conferimento-ccr',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/features/conferimenti/dettaglio-conferimenti/ccr/ccr.component').then(
            (x) => x.CcrComponent,
          ),
      },
      {
        path: 'nuovo-soggetto',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/soggetti/new-soggetto/new-soggetto.component').then(
            (x) => x.NewSoggettoComponent,
          ),
        data: {
          breadcrumb: [
            {
              name: 'Dettaglio conferimenti',
              route: 'dettaglio-conferimento-ccr',
            },
            { name: 'Nuovo soggetto', route: 'nuovo-soggetto' },
          ],
        },
      },
      {
        path: 'dettaglio-soggetto/:idSoggetto',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/soggetti/details-soggetto/details-soggetto.component').then(
            (x) => x.DetailsSoggettoComponent,
          ),
        data: {
          breadcrumb: [
            {
              name: 'Dettaglio conferimenti',
              route: 'dettaglio-conferimento-ccr',
            },
            { name: 'Dettaglio soggetto', route: 'nuovo-soggetto' },
          ],
        },
      },
      {
        path: 'modifica-soggetto/:idSoggetto',
        loadComponent: () =>
          import('./pages/features_shared/anagrafica-soggetti-utenze-condomini/soggetti/new-soggetto/new-soggetto.component').then(
            (x) => x.NewSoggettoComponent,
          ),
        data: {
          breadcrumb: [
            {
              name: 'Dettaglio conferimenti',
              route: 'dettaglio-conferimento-ccr',
            },
            { name: 'Modifica soggetto', route: 'nuovo-soggetto' },
          ],
        },
      },
      {
        path: 'dettaglio-conferimenti/:idSoggetto/:idConferimento',
        loadComponent: () =>
          import('./pages/features/conferimenti/dettaglio-conferimenti/ccr/ccr.component').then(
            (x) => x.CcrComponent,
          ),
        data: {
          breadcrumb: [
            {
              name: 'Dettaglio conferimenti',
              route: 'dettaglio-conferimento-ccr',
            },
            {
              name: 'Dettaglio conferimenti ccr',
              route: 'dettaglio-conferimenti',
            },
          ],
        },
      },
      {
        path: 'modifica-conferimenti/:idSoggetto/:idConferimento',
        loadComponent: () =>
          import('./pages/features/conferimenti/dettaglio-conferimenti/ccr/registra-conferimenti/registra-conferimenti.component').then(
            (x) => x.RegistraConferimentiComponent,
          ),
        data: {
          breadcrumb: [
            {
              name: 'Dettaglio conferimenti',
              route: 'dettaglio-conferimento-ccr',
            },
            { name: 'Modifica conferimenti', route: 'modifica-conferimenti' },
          ],
        },
      },
    ],
    canActivate: [risorseGuard],
    data: { idSidenav: [IDRISORSESIDENAV.dettaglio_conferimenti_ccr] },
  },
  // Guida raccolta
  {
    path: 'guida-raccolta',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/features/ticketing-sportello-online/app-cittadino-sportello-online/guida-raccolta/guida-raccolta.component').then(
            (x) => x.GuidaRaccoltaComponent,
          ),
      },
      {
        path: 'dettaglio-guida-raccolta/:idGuidaRaccolta',
        loadComponent: () =>
          import('./pages/features/ticketing-sportello-online/app-cittadino-sportello-online/guida-raccolta/dettaglio-raccolta/dettaglio-raccolta.component').then(
            (x) => x.DettaglioRaccoltaComponent,
          ),
      },
      {
        path: 'nuova-guida-raccolta',
        loadComponent: () =>
          import('./pages/features/ticketing-sportello-online/app-cittadino-sportello-online/guida-raccolta/edit-guida-raccolta/edit-guida-raccolta.component').then(
            (x) => x.EditGuidaRaccoltaComponent,
          ),
        data: {
          breadcrumb: [
            { name: 'Guida raccolta', route: 'guida-raccolta' },
            { name: 'Nuova guida raccolta', route: '' },
          ],
        },
      },
      {
        path: 'modifica-guida-raccolta/:idGuidaRaccolta',
        loadComponent: () =>
          import('./pages/features/ticketing-sportello-online/app-cittadino-sportello-online/guida-raccolta/edit-guida-raccolta/edit-guida-raccolta.component').then(
            (x) => x.EditGuidaRaccoltaComponent,
          ),
        data: {
          breadcrumb: [
            { name: 'Guida raccolta', route: 'guida-raccolta' },
            { name: 'Modifica guida raccolta', route: '' },
          ],
        },
      },
    ],
    canActivate: [risorseGuard],
    data: { idSidenav: [IDRISORSESIDENAV.guida_raccolta] },
  },
  // Calendario raccolta
  {
    path: 'calendario-raccolta',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/features/ticketing-sportello-online/app-cittadino-sportello-online/calendario-raccolta/calendario-raccolta.component').then(
            (x) => x.CalendarioRaccoltaComponent,
          ),
      },
      {
        path: 'pianifica-raccolta',
        loadComponent: () =>
          import('./pages/features/ticketing-sportello-online/app-cittadino-sportello-online/calendario-raccolta/pianifica-raccolta/pianifica-raccolta.component').then(
            (x) => x.PianificaRaccoltaComponent,
          ),
        data: {
          breadcrumb: [
            { name: 'Calendario raccolta', route: 'calendario-raccolta' },
            { name: 'Pianifica raccolta', route: '' },
          ],
        },
      },
    ],
    canActivate: [risorseGuard],
    data: { idSidenav: [IDRISORSESIDENAV.calendario_raccolta] },
  },
  // Conferimento
  {
    path: 'conferimenti',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/features/conferimenti/dettaglio-conferimenti/dettaglio-conferimenti.component').then(
            (x) => x.DettaglioConferimentiComponent,
          ),
      },
      {
        path: 'registra-conferimenti/:idUtenza',
        loadComponent: () =>
          import('./pages/features/conferimenti/dettaglio-conferimenti/ccr/registra-conferimenti/registra-conferimenti.component').then(
            (x) => x.RegistraConferimentiComponent,
          ),
        data: {
          breadcrumb: [
            { name: 'Dettaglio conferimenti', route: 'conferimenti' },
            { name: 'Registra conferimenti', route: 'registra-conferimenti' },
          ],
        },
      },
    ],
    canActivate: [risorseGuard],
    data: { idSidenav: [IDRISORSESIDENAV.dettaglio_conferimenti] },
  },
  // CRM
  {
    path: 'gestione-richieste-crm',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/features/ticketing-sportello-online/gestione-richieste/gestione-richieste-crm.component').then(
            (x) => x.GestioneRichiesteCrmComponent,
          ),
      },
      {
        path: 'ritiri-on-demand',
        loadComponent: () =>
          import('./pages/features/ticketing-sportello-online/gestione-richieste/rifiuti-on-demand-crm/rifiuti-on-demand-crm.component').then(
            (x) => x.RifiutiOnDemandCrmComponent,
          ),
      },
      {
        path: 'rifiuti',
        loadComponent: () =>
          import('./pages/features/ticketing-sportello-online/gestione-richieste/rifiuti-crm/rifiuti-crm.component').then(
            (x) => x.RifiutiCrmComponent,
          ),
      },
      {
        path: 'tari',
        loadComponent: () =>
          import('./pages/features/ticketing-sportello-online/gestione-richieste/tari-crm/tari-crm.component').then(
            (x) => x.TariCrmComponent,
          ),
      },
      {
        path: 'dettaglio-ritiri-on-demand/:idTicket',
        loadComponent: () =>
          import('./pages/features/ticketing-sportello-online/gestione-richieste/rifiuti-on-demand-crm/dettaglio-ritiri-on-demand/dettaglio-ritiri-on-demand.component').then(
            (x) => x.DettaglioRitiriOnDemandComponent,
          ),
        data: {
          breadcrumb: [
            { name: 'Lista ticket', route: 'gestione-richieste-crm' },
            { name: 'Dettaglio ticket', route: '' },
          ],
        },
      },
      {
        path: 'modifica-ritiri-on-demand/:idTicket',
        loadComponent: () =>
          import('./pages/features/ticketing-sportello-online/gestione-richieste/rifiuti-on-demand-crm/edit-ritiri-on-demand/edit-ritiri-on-demand.component').then(
            (x) => x.EditRitiriOnDemandComponent,
          ),
        data: {
          idFlusso: [IDRISORSEFLUSSO.ritiri_on_demand],
          breadcrumb: [
            { name: 'Lista ticket', route: 'gestione-richieste-crm' },
            { name: 'Modifica ticket', route: '' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        path: 'dettaglio-rifiuti/:idTicket',
        loadComponent: () =>
          import('./pages/features/ticketing-sportello-online/gestione-richieste/rifiuti-crm/dettaglio-rifiuti/dettaglio-rifiuti.component').then(
            (x) => x.DettaglioRifiutiComponent,
          ),
        data: {
          breadcrumb: [
            { name: 'Lista rifiuti', route: 'gestione-richieste-crm' },
            { name: 'Dettaglio ticket', route: '' },
          ],
        },
      },
      {
        path: 'modifica-rifiuti/:idTicket',
        loadComponent: () =>
          import('./pages/features/ticketing-sportello-online/gestione-richieste/rifiuti-crm/edit-rifiuti/edit-rifiuti.component').then(
            (x) => x.EditRifiutiComponent,
          ),
        data: {
          idFlusso: [IDRISORSEFLUSSO.rifiuti],
          breadcrumb: [
            { name: 'Lista rifiuti', route: 'gestione-richieste-crm' },
            { name: 'Modifica ticket', route: '' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        path: 'dettaglio-tari/:idTicket',
        loadComponent: () =>
          import('./pages/features/ticketing-sportello-online/gestione-richieste/tari-crm/dettaglio-tari/dettaglio-tari.component').then(
            (x) => x.DettaglioTariComponent,
          ),
        data: {
          breadcrumb: [
            { name: 'Lista tari', route: 'gestione-richieste-crm' },
            { name: 'Dettaglio ticket', route: '' },
          ],
        },
      },
      {
        path: 'modifica-tari/:idTicket',
        loadComponent: () =>
          import('./pages/features/ticketing-sportello-online/gestione-richieste/tari-crm/edit-tari/edit-tari.component').then(
            (x) => x.EditTariComponent,
          ),
        data: {
          idFlusso: [IDRISORSEFLUSSO.tari],
          breadcrumb: [
            { name: 'Lista tari', route: 'gestione-richieste-crm' },
            { name: 'Modifica ticket', route: '' },
          ],
        },
        canActivate: [permissionGuard],
      },
      {
        path: 'nuovo-ticket/:idUtenza',
        loadComponent: () =>
          import('./pages/features/ticketing-sportello-online/gestione-richieste/tipologia-selection/tipologia-selection.component').then(
            (x) => x.TipologiaSelectionComponent,
          ),
        data: {
          breadcrumb: [
            { name: 'Guida raccolta', route: 'gestione-richieste-crm' },
            { name: 'Nuovo ticket', route: '' },
          ],
        },
      },
      {
        path: 'wizard/:idUtenza/:activityType',
        loadComponent: () =>
          import('./pages/features/distribuzione-censimento/attivita/activity-wizard/activity-wizard.component').then(
            (x) => x.ActivityWizardComponent,
          ),
        data: {
          idSidenav: [IDRISORSESIDENAV.gestione_ticket],
          breadcrumb: [
            { name: 'Guida raccolta', route: 'gestione-richieste-crm' },
            { name: 'Nuovo ticket', route: 'nuovo-ticket-tari' },
            { name: 'Wizard CRM', route: '' },
          ],
        },
      },
    ],
    canActivate: [risorseGuard],

    data: { idSidenav: [IDRISORSESIDENAV.gestione_ticket] },
  },
  {
    path: 'news-crm',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/features/ticketing-sportello-online/news-crm/news-crm.component').then(
            (x) => x.NewsCrmComponent,
          ),
      },
      {
        path: 'nuova-news',
        loadComponent: () =>
          import('./pages/features/ticketing-sportello-online/news-crm/edit-news/edit-news.component').then(
            (x) => x.EditNewsComponent,
          ),
        data: {
          idSidenav: [IDRISORSESIDENAV.gestione_ticket],
          breadcrumb: [
            { name: 'Lista news', route: 'news-crm' },
            { name: 'Nuova news', route: '' },
          ],
        },
      },
      {
        path: 'modifica-news/:idNews',
        loadComponent: () =>
          import('./pages/features/ticketing-sportello-online/news-crm/edit-news/edit-news.component').then(
            (x) => x.EditNewsComponent,
          ),
        data: {
          idSidenav: [IDRISORSESIDENAV.gestione_ticket],
          breadcrumb: [
            { name: 'Lista news', route: 'news-crm' },
            { name: 'Modifica news', route: '' },
          ],
        },
      },
      {
        path: 'duplica-news/:idNews',
        loadComponent: () =>
          import('./pages/features/ticketing-sportello-online/news-crm/edit-news/edit-news.component').then(
            (x) => x.EditNewsComponent,
          ),
        data: {
          idSidenav: [IDRISORSESIDENAV.gestione_ticket],
          breadcrumb: [
            { name: 'Lista news', route: 'news-crm' },
            { name: 'Duplica news', route: '' },
          ],
        },
      },
      {
        path: 'dettaglio-news/:idNews',
        loadComponent: () =>
          import('./pages/features/ticketing-sportello-online/news-crm/dettaglio-news/dettaglio-news.component').then(
            (x) => x.DettaglioNewsComponent,
          ),
      },
    ],
    canActivate: [risorseGuard],
    data: { idSidenav: [IDRISORSESIDENAV.gestione_ticket] },
  },
  {
    path: 'lista-servizi',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/features/servizi/lista-servizi/lista-servizi.component').then(
            (x) => x.ListaServiziComponent,
          ),
      },
      {
        path: 'nuovo-servizio',
        loadComponent: () =>
          import('./pages/features/servizi/lista-servizi/nuovo-servizio/nuovo-servizio.component').then(
            (x) => x.NuovoServizioComponent,
          ),
        data: {
          breadcrumb: [
            { name: 'Lista servizi', route: 'lista-servizi' },
            { name: 'Nuovo servizio', route: '' },
          ],
        },
      },
      {
        path: 'wizard-servizi/:activityType',
        loadComponent: () =>
          import('./pages/features/distribuzione-censimento/attivita/activity-wizard/activity-wizard.component').then(
            (x) => x.ActivityWizardComponent,
          ),
        data: {
          idSidenav: [IDRISORSESIDENAV.servizi_list],
          breadcrumb: [
            { name: 'Lista servizi', route: 'lista-servizi' },
            {
              name: 'Nuovo servizio',
              route: 'nuovo-servizio',
            },
          ],
        },
        canActivate: [permissionGuard],
        canDeactivate: [ActivityWizardDeactivateGuard],
      },
      {
        path: 'dettaglio-servizio/:idServizio/:tipologiaServizio',
        loadComponent: () =>
          import('./pages/features/servizi/lista-servizi/manage-servizio/view-servizio.component').then(
            (x) => x.DettaglioServizioComponent,
          ),
        data: {
          breadcrumb: [
            { name: 'Lista servizi', route: 'lista-servizi' },
            { name: 'Dettaglio servizio', route: '' },
          ],
        },
      },
      {
        path: 'dettaglio-servizio/:idServizio/:tipologiaServizio/associa-utenze',
        loadComponent: () =>
          import('./pages/features/servizi/lista-servizi/manage-servizio/componenti-gestione-servizio/componenti-dettaglio/dettaglio-dati-utenze/associa-utenze-servizio/associa-utenze-servizio.component').then(
            (x) => x.AssociaUtenzeServizioComponent,
          ),
        data: {
          breadcrumb: [
            { name: 'Lista servizi', route: 'lista-servizi' },
            { name: 'Dettaglio servizio', route: 'dettaglio-servizio' },
            { name: 'Associa utenze', route: '' },
          ],
        },
      },
    ],
    canActivate: [risorseGuard],
    data: { idSidenav: [IDRISORSESIDENAV.servizi_list] },
  },

  {
    path: 'servizi-giornalieri',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/features/servizi/servizi-giornalieri/servizi-giornalieri.component').then(
            (x) => x.ServiziGiornalieriComponent,
          ),
      },
      {
        path: 'gestisci-servizi-operatori',
        loadComponent: () =>
          import('./pages/features/servizi/servizi-giornalieri/gestisci-veicoli-operatori/gestisci-veicoli-operatori.component').then(
            (x) => x.GestisciVeicoliOperatoriComponent,
          ),
        data: {
          breadcrumb: [
            { name: 'Servizi giornalieri', route: 'servizi-giornalieri' },
            { name: 'Gestisci servizi e operatori', route: '' },
          ],
        },
      },
    ],
    canActivate: [risorseGuard],
    data: { idSidenav: [IDRISORSESIDENAV.servizi_list] },
  },
  // Zonazione
  {
    path: 'tipologia-zona',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/features/zonazione-del-territorio/zonazione.component').then(
            (x) => x.ZonazioneComponent,
          ),
      },
      {
        path: 'dettaglio-tipologia/:idTipologia',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/features/zonazione-del-territorio/dettaglio-tipologia/dettaglio-tipologia.component').then(
                (x) => x.DettaglioTipologiaComponent,
              ),
            data: {
              breadcrumb: [
                { name: 'Lista tipologie', route: 'tipologia-zona' },
                { name: 'Dettaglio tipologia', route: 'dettaglio-tipologia' },
              ],
            },
          },
          {
            path: 'lista-utenze/:idZona',
            children: [
              {
                path: '',
                loadComponent: () =>
                  import('./pages/features/zonazione-del-territorio/zone/list-zone/list-utenze-zone/list-utenze-zone.component').then(
                    (x) => x.ListUtenzeZoneComponent,
                  ),
                data: {
                  breadcrumb: [
                    { name: 'Lista tipologie', route: 'tipologia-zona' },
                    {
                      name: 'Dettaglio tipologia',
                      route: 'dettaglio-tipologia',
                    },
                    { name: 'Lista utenze', route: 'lista-utenze' },
                  ],
                },
              },
              {
                path: 'associa-utenze',
                loadComponent: () =>
                  import('./pages/features/zonazione-del-territorio/zone/list-zone/list-utenze-zone/associa-utenze-zone/associa-utenze-zone.component').then(
                    (x) => x.AssociaUtenzeZoneComponent,
                  ),
                data: {
                  breadcrumb: [
                    { name: 'Lista tipologie', route: 'tipologia-zona' },
                    {
                      name: 'Dettaglio tipologia',
                      route: 'dettaglio-tipologia',
                    },
                    { name: 'Lista utenze', route: 'lista-utenze' },
                  ],
                },
              },
            ],
          },
        ],
      },

      {
        path: 'modifica-tipologia/:idTipologia',
        loadComponent: () =>
          import('./pages/features/zonazione-del-territorio/new-tipologia/new-tipologia.component').then(
            (x) => x.NewTipologiaComponent,
          ),
        data: {
          breadcrumb: [
            { name: 'Lista tipologie', route: 'zonazione' },
            { name: 'Modifica tipologia', route: 'modifica-tipologia' },
          ],
        },
      },
      {
        path: 'nuova-tipologia',
        loadComponent: () =>
          import('./pages/features/zonazione-del-territorio/new-tipologia/new-tipologia.component').then(
            (x) => x.NewTipologiaComponent,
          ),
        data: {
          breadcrumb: [
            { name: 'Lista tipologie', route: 'zonazione' },
            { name: 'Nuova tipologia', route: 'nuova-tipologia' },
          ],
        },
      },
    ],
    canActivate: [risorseGuard],
    data: { idSidenav: [IDRISORSESIDENAV.tipologia_zona] },
  },
  {
    path: 'guida-supporto',
    loadComponent: () =>
      import('./pages/guida-supporto/guida-supporto.component').then(
        (x) => x.GuidaSupportoComponent,
      ),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'auth/login',
  },
  {
    path: '**',
    redirectTo: 'auth/login',
  },
];
